import { atom, selector } from 'recoil';

export const updateFleetReportsState = atom<boolean>({
  key: 'app.myFleet.reports.update',
  default: false,
});

export const updateOperationalReportsState = atom<string | undefined>({
  key: 'app.myFleet.reports.operational.update',
  default: undefined,
});

export const fleetOperationalReportIsUpdatingState = selector<boolean>({
  key: 'app.myFleet.reports.operational.isUpdating',
  get: ({ get }) => {
    return get(updateOperationalReportsState) === 'update';
  },
});

export const fleetReportStartDateState = atom<number | null | undefined>({
  key: 'app.myFleet.reports.startTime',
  default: undefined,
});

export const fleetReportEndDateState = atom<number | null | undefined>({
  key: 'app.myFleet.reports.endTime',
  default: undefined,
});

export const fleetReportSelectedGroupIdState = atom<string | undefined>({
  key: 'app.myFleet.reports.selectedGroupId',
  default: undefined,
});

export const fleetReportSearchTypeState = atom<number>({
  key: 'app.myFleet.reports.searchType',
  default: 0,
});

export const fleetReportSelectedAssetIdState = atom<string | undefined>({
  key: 'app.myFleet.reports.selectedAssetId',
  default: undefined,
});
